export function isNullOrUndefined(obj: unknown): obj is null | undefined;
export function isNullOrUndefined<
  DefinedType,
  UndefinedType extends null | undefined,
>(obj: DefinedType | UndefinedType): obj is UndefinedType;
export function isNullOrUndefined(obj: unknown): boolean {
  return obj === undefined || obj === null;
}
